export default __webpack_public_path__ + "static/media/signup.d6c8ba17.png";